<template>
  <nuttrema-layout-page-content class="is-register">

    <nuttrema-loader v-if="InvitationAccept.fetching || InvitationPreAccept.fetching"></nuttrema-loader>

    <template v-else-if="_isEmpty(token) || _get(InvitationPreAccept, 'error.constraint') === 'invalid_token_message'">
      <nuttrema-empty-result icon="far fa-qrcode">
        <template slot="text">
          <h1>{{ $t('label.missing_or_invalid_token') }}</h1>
          <h4>{{ $t('label.missing_token_help') }}</h4>
        </template>
      </nuttrema-empty-result>
    </template>

    <form-join-instance
       v-else
       theme="global"
       class="is-no-center-scroll is-center-vertical"
      :edit="true"
      :token="token"
      :InvitationAccept="InvitationAccept"
      :InvitationPreAccept="InvitationPreAccept"
      @submit="onFormSubmit">
    </form-join-instance>

  </nuttrema-layout-page-content>
</template>

<script>
import { get } from 'lodash';
import { mapActions } from 'vuex';

import { PERSON } from 'constants/types';

import PageProps from 'components/mixins/page-props';
import RedirectLogged from 'components/mixins/redirect-logged';

import NuttremaLayoutPageContent from 'components/ui/layout/nuttrema-layout-page-content';

import FormJoinInstance from './form-join-instance';

export default {
  name: 'page-join-instance',
  mixins: [
    PageProps,
    RedirectLogged,
  ],
  props: {
    token: {
      required: false,
      default: null,
    },
  },
  components: {
    FormJoinInstance,
    NuttremaLayoutPageContent,
  },
  data() {
    return {
      type: PERSON.TEAM_MEMBER,
    };
  },
  methods: {
    ...mapActions([
      'PersonAcceptInvitation',
    ]),
    onFormSubmit(data) {
      const payload = get(data, 'payload');
      const credentials = get(data, 'credentials');

      this.PersonAcceptInvitation({
        type: this.type,
        payload,
      }).then(() => {
        this.successNotification({ message: 'message.success_registration' });

        this.$auth.login({
          url: '/auth/login',
          data: credentials,
          rememberMe: false,
          fetchUser: true,
          success() {
            this.redirectLogin();
          },
          error(error) {
            console.log('error rrrr', error, error.toString());
          },
        });
      }).catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
  },
  computed: {
    InvitationAccept() {
      return this.$store.getters.InvitationAccept(this.type);
    },
    InvitationPreAccept() {
      return this.$store.getters.InvitationPreAccept(this.type);
    },
  },
  created() {
    this.$store.dispatch('GetInvitationPreAccept', { type: this.type, query: { token: this.token } });
    this.$store.dispatch('InitPersonAcceptInvitation', { type: this.type });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearInvitationPreAccept', { type: this.type });
    this.$store.dispatch('ClearInvitationAccept', { type: this.type });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/public/join-instance/page-join-instance.vue